import Vue from 'vue';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faInstagram as fabInstagram,
  faFacebook as fabFacebook,
  faTwitter as fabTwitter,
} from '@fortawesome/free-brands-svg-icons';

import {
  faArchive as farArchive,
  faArrowCircleRight as farArrowCircleRight,
  faAt as farAt,
  faBorderAll as farBorderAll,
  faBringForward as farBringForward,
  faCaretDown as farCaretDown,
  faChevronCircleRight as farChevronCircleRight,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faClock as farClock,
  faColumns as farColumns,
  faHdd as farHdd,
  faFilter as farFilter,
  faHeart as farHeart,
  faHomeAlt as farHomeAlt,
  faKey as farKey,
  faLaptop as farLaptop,
  faMemory as farMemory,
  faMicrochip as farMicrochip,
  faMinus as farMinus,
  faMoon as farMoon,
  faNewspaper as farNewspaper,
  faPlus as farPlus,
  faSave as farSave,
  faSearch as farSearch,
  faServer as farServer,
  faShoppingCart as farShoppingCart,
  faSpinnerThird as farSpinnerThird,
  faStar as farStar,
  faSun as farSun,
  faTags as farTags,
  faTrashAlt as farTrashAlt,
  faUnlock as farUnlock,
  faUsdSquare as farUsdSquare,
  faUserAlt as farUserAlt,
  faUserCircle as farUserCircle,
} from '../components/vendor/fontawesome/pro-regular-svg-icons';

import {
  faMinusSquare as falMinusSquare,
  faPlusSquare as falPlusSquare,
  faUnlock as falUnlock,
  faUserAlt as falUserAlt,
} from '../components/vendor/fontawesome/pro-light-svg-icons';

import {
  faStar as fasStar,
  faSwatchbook as fasSwatchbook,
  faSuitcaseRolling as fasSuitcaseRolling,
  faRocketLaunch as fasRocketLaunch,
} from '../components/vendor/fontawesome/pro-solid-svg-icons';

import {
  faChevronDoubleDown as fadChevronDoubleDown,
  faChevronDoubleUp as fadChevronDoubleUp,
  faInfoCircle as fadInfoCircle,
  faKey as fadKey,
} from '../components/vendor/fontawesome/pro-duotone-svg-icons';

library.add(
  fabFacebook,
  fabInstagram,
  fabTwitter,
  fadChevronDoubleDown,
  fadChevronDoubleUp,
  fadInfoCircle,
  fadKey,
  falMinusSquare,
  falPlusSquare,
  falUnlock,
  falUserAlt,
  farArchive,
  farArrowCircleRight,
  farAt,
  farBorderAll,
  farBringForward,
  farCaretDown,
  farChevronCircleRight,
  farChevronLeft,
  farChevronRight,
  farClock,
  farColumns,
  farFilter,
  farHdd,
  farHeart,
  farHomeAlt,
  farKey,
  farLaptop,
  farMemory,
  farMicrochip,
  farMinus,
  farMoon,
  farNewspaper,
  farPlus,
  farSave,
  farSearch,
  farServer,
  farShoppingCart,
  farSpinnerThird,
  farStar,
  farSun,
  farTags,
  farTrashAlt,
  farUnlock,
  farUsdSquare,
  farUserAlt,
  farUserCircle,
  fasStar,
  fasSuitcaseRolling,
  fasSwatchbook,
  fasRocketLaunch,
);

dom.watch();

Vue.component('font-awesome-icon', FontAwesomeIcon);
